import React, { useEffect, useRef } from "react";
import { bucketUrl } from "../../config";

interface CropImageProps {
  src: string;
  sourceX?: number;
  sourceY?: number;
  sourceWidth?: number;
  sourceHeight?: number;
  width: number; 
  height: number; 
}

const CropImage: React.FC<CropImageProps> = ({
  src,
  sourceX,
  sourceY,
  sourceWidth,
  sourceHeight,
  width,
  height,
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext("2d");
    if (!context) return;

    const imageObj = new window.Image();
    imageObj.crossOrigin = "anonymous";
    imageObj.onload = function () {
      let cropX = sourceX;
      let cropY = sourceY;
      let cropWidth = sourceWidth;
      let cropHeight = sourceHeight;

      if (
        cropX === undefined ||
        cropY === undefined ||
        cropWidth === undefined ||
        cropHeight === undefined
      ) {
        const minSide = Math.min(imageObj.width, imageObj.height);
        cropWidth = cropHeight = minSide;
        cropX = Math.floor((imageObj.width - minSide) / 2);
        cropY = Math.floor((imageObj.height - minSide) / 2);
      }

      const destWidth = cropWidth;
      const destHeight = cropHeight;
      const destX = width / 2 - destWidth / 2;
      const destY = height / 2 - destHeight / 2;
      context.clearRect(0, 0, width, height);
      context.drawImage(
        imageObj,
        cropX,
        cropY,
        cropWidth,
        cropHeight,
        destX,
        destY,
        destWidth,
        destHeight
      );
    };
    imageObj.src = bucketUrl +  src;
  }, [src, sourceX, sourceY, sourceWidth, sourceHeight, width, height]);

  return <canvas ref={canvasRef} width={width} height={height} />;
};

export default CropImage;

